import MainHeader from "../../layouts/MainHeader";
import newsPageData from "../../data/arabic/subpages/news-page-data-ar";
import BlogSection from "../../components/sections/BlogSection/BlogSection";
import Footer from "../../layouts/Footer";

const NewsPageAr = () => {
  return (
      <main className="page" id="main">
        <div className="sticky-view">
          <div className="sticky-container">
            <MainHeader 
              image={{
                src : require(`../../assets/images/headers/${newsPageData.header.image.name}`),
                alt : newsPageData.header.image.alt,
              }}
              title={newsPageData.header.title}
            />
          </div>
          <div className="sticky-container-two" id="mainContent">
            <div className="space-25"></div>
            <div className="wrapper-small">
              {
              newsPageData.sections.map((section, index) => (
                <BlogSection 
                  page="news"
                  key={index}
                  sectionIndex={index}
                  title={section.sectionTitle}
                  articles={section.articles}
                />
              ))
              }
            </div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <Footer withBlogs={false} />
          </div>
        </div>
      </main>
  )
}

export default NewsPageAr;